define.alias("shared/utils/number-helpers/floor-to-significant-digits", "settings/utils/number-helpers/floor-to-significant-digits");